import { render, staticRenderFns } from "./modalPrivacy.vue?vue&type=template&id=4fb7e6cb&scoped=true"
import script from "./modalPrivacy.vue?vue&type=script&lang=js"
export * from "./modalPrivacy.vue?vue&type=script&lang=js"
import style0 from "./modalPrivacy.vue?vue&type=style&index=0&id=4fb7e6cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb7e6cb",
  null
  
)

export default component.exports